import axios from 'axios';

export default (formData) =>
  axios.post(`${process.env.VUE_APP_API_ENDPOINT}/document-manager/upload-at-client`, formData);
